import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useUserAuth } from "../context/userAuthContext";

const ProtectedRoute = ({ children }) => {
  const navigate = useNavigate();
  const { user } = useUserAuth();
  const [loading, setLoading] = useState(true);

  // List of allowed admin emails
  const allowedAdmins = [
    "cmahato2000@gmail.com",
    "lahantraders@gmail.com",
    "dipendra.mahato31@gmail.com"
  ];

  useEffect(() => {
    const loadingTimer = setTimeout(() => {
      setLoading(false);
      if (!user) {
        navigate("/");
      } else if (!allowedAdmins.includes(user.email)) {
        navigate("/");
      }
    }, 2000);

    return () => clearTimeout(loadingTimer); // Cleanup the timer if the component unmounts.
  }, [user, navigate]);

  if (loading) {
    return <div style={{ paddingTop: '100px' }}>Authenticating Admin...</div>;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
